import { useState } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@/hooks';
import { selectSecrets } from '@/modules/secrets/services/selectors';
import { SearchSecretAttributeType } from '@/modules/secrets/types';
import { Caret } from '@/modules/ui/components/Icon/Caret';

import { useSecretsAttributesFilter } from '../../../hooks/useSecretsAttributesFilter';
import * as felaRules from './SecretFilters.rules';
import { SecretTypeFilter } from './SecretTypeFilter';
import { SortByFilter } from './SortByFilter';
import { TagsFilter } from './TagsFilter';

export const SecretFilters = () => {
    const { css } = useFela();

    const [expanded, setExpanded] = useState(false);
    const [animating, setAnimating] = useState(false);

    const { secretType } = useAppSelector(selectSecrets);
    const { filter } = useSecretsAttributesFilter();

    const hasActiveFilter = Boolean(secretType) || filter.some(attribute => attribute.type === SearchSecretAttributeType.TAG);

    return (
        <>
            <button
                type='button'
                aria-expanded={expanded}
                className={css(felaRules.toggle)}
                onClick={() => {
                    setExpanded(value => !value);
                    setAnimating(true);
                }}
            >
                {hasActiveFilter && <span className={css(felaRules.dot)} />}
                <FormattedMessage id='secret.filter.toggle' />
                <Caret className={css(expanded ? felaRules.toggleCaretOpen : felaRules.toggleCaret)} />
            </button>
            <div
                className={css(felaRules.collapse, expanded && felaRules.collapseExpanded)}
                onTransitionEnd={event => {
                    if (event.target === event.currentTarget) {
                        setAnimating(false);
                    }
                }}
            >
                {/* Clip only while collapsed or animating — open dropdowns render inside and must not be cut off */}
                <div className={css(felaRules.collapseInner, (animating || !expanded) && felaRules.collapseInnerClipped)}>
                    <div className={css(felaRules.container)}>
                        <SortByFilter />
                        <SecretTypeFilter />
                        <TagsFilter />
                    </div>
                </div>
            </div>
        </>
    );
};
